'use client';

import React, { useState, type FC } from 'react';
import { useProfile } from '../queries/useProfileQueries';
import { useUiMotionEnabled } from '../hooks/useMotion';
import { useCountUp } from '../hooks/useCountUp';

interface CreditsChangeFlashProps {
  amount: number;
  format: (amount: number) => string;
}

type FlashState = {
  amount: number;
  tracked: boolean;
  direction: 'up' | 'down' | null;
  seq: number;
};

export const CreditsChangeFlash: FC<CreditsChangeFlashProps> = ({ amount, format }) => {
  const { data: profile } = useProfile();
  const tracked = profile !== undefined;
  const motionEnabled = useUiMotionEnabled();

  const [state, setState] = useState<FlashState>({ amount, tracked, direction: null, seq: 0 });

  if (state.amount !== amount || state.tracked !== tracked) {
    const changed = state.amount !== amount;
    const direction = changed && tracked && state.tracked ? (amount > state.amount ? 'up' : 'down') : null;
    setState({ amount, tracked, direction, seq: direction ? state.seq + 1 : state.seq });
  }

  const animationClass =
    motionEnabled && state.direction === 'up'
      ? 'animate-shot-credits-up'
      : motionEnabled && state.direction === 'down'
        ? 'animate-shot-credits-down'
        : '';

  const displayed = useCountUp(amount, tracked && state.tracked);

  return (
    <span key={state.seq} data-credits-value className={`inline-block ${animationClass}`}>
      {format(displayed)}
    </span>
  );
};
